export const PARTNER_ID_MAX = 64;
export const CHAN_MAX = 128;

const PARTNER_ID_ALLOWED = /[^a-zA-Z0-9_-]/g;
const CHAN_FORBIDDEN = /["'<>&\\\s]/g;

export function sanitizePartnerId(value: string): string {
  return value.replace(PARTNER_ID_ALLOWED, "").slice(0, PARTNER_ID_MAX);
}

export function sanitizeChan(value: string): string {
  return value.replace(CHAN_FORBIDDEN, "").slice(0, CHAN_MAX);
}
